import { useQuery } from '@apollo/client'
import { GetServerSideProps, InferGetServerSidePropsType, NextPage } from 'next'

import FollowVenue from 'components/follow/venue'
import AuctionsBanner from 'components/venues/auctions-banner'
import Events from 'components/venues/events'
import { GetVenueBySlugQuery } from 'gql'
import Sidebar from '~shared/Side'
import { MetaTags } from '~shared'
import { Grid, Layout } from '~ui'
import { useQueryParams } from '~hooks'
import { addApolloState, initializeApollo } from '~services/apollo'
import { GET_VENUE_BY_SLUG } from 'gql/queries'

export const getServerSideProps: GetServerSideProps = async ({ query: { slug } }) => {
  const apollo = initializeApollo()

  const { data, error } = await apollo.query<GetVenueBySlugQuery>({
    query: GET_VENUE_BY_SLUG,
    variables: { slug },
  })

  return addApolloState(apollo, {
    notFound: error || !data.venue,
    props: {},
  })
}

const VenueDetail: NextPage<InferGetServerSidePropsType<typeof getServerSideProps>> = () => {
  const {
    query: { slug },
  } = useQueryParams()

  const { data } = useQuery<GetVenueBySlugQuery>(GET_VENUE_BY_SLUG, {
    variables: { slug },
  })

  const { id, zip, name, city, state, venuePhoto, description, streetAddress } = data.venue

  return (
    <Layout>
      <MetaTags
        imageSrc={venuePhoto}
        description={description}
        title={`${name} - ${city}, ${state} ${zip}, ${streetAddress}`}
      />
      <Layout.Header grantedSecureBanner />
      <Layout.Main>
        <Layout.Main.Sidebar>
          <Sidebar image={venuePhoto} title={name} info={description}>
            <FollowVenue slug={slug} id={id} starName={name} />
          </Sidebar>
        </Layout.Main.Sidebar>
        <Layout.Main.Content>
          <Layout.Main.Content.Widget withPadding>
            <Grid gap="1.5rem">
              <AuctionsBanner venueSlug={slug} />
              <Events venueSlug={slug} />
            </Grid>
          </Layout.Main.Content.Widget>
        </Layout.Main.Content>
      </Layout.Main>
      <Layout.Footer />
    </Layout>
  )
}

export default VenueDetail
